<template>
	<div class="home-profile">
		<img class="left-icon" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/ciif-left.png" alt="">
		<img class="center-icon" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/ciif.png" alt="">
		<img class="right-icon" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/chilun.png" alt="">
		<img class="left" :src="detail.img" alt="">
		<div class="right">
			<div class="right1">
				<scrollText reverse></scrollText>
			</div>
			<div class="right2" v-html="detail['title' + En]"></div>
			<div class="right3">
				{{ detail['content' + En] }}
			</div>
			<div class="btns">
				<a href="javascript:void(0)" class="btn" @click="toHistory">
					{{ $t('newbanner6') }}
					<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
					<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
				</a>
				<a class="btn" href="https://gociif.ciif-expo.com/" target="_blank">
					{{ $t('newbanner7') }}
					<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
					<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import protal from "@/api/protal";
export default {
	name: 'news_events',
	data() {
		return {
			detail: {}
		}
	},
	created() {
		this.getData()
	},
	methods: {
		getData() {
			protal.getJson('home_profile', data => {
				this.detail = data
			})
		},
		toHistory() {
			this.$router.push('/history')
		}
	}
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
	.home-profile {
		width: 1640px;
		margin: 0 auto;
		padding-top: 150px;
		padding-left: 780px;
		padding-bottom: 260px;
		border-bottom: 1px solid rgba(11, 36, 63, 0.2);
		position: relative;

		.left-icon {
			position: absolute;
			left: 0;
			bottom: 19px;
			width: auto;
			height: 154px;
		}

		.center-icon {
			position: absolute;
			width: 780px;
			height: auto;
			left: 430px;
			bottom: 0;
		}

		.right-icon {
			position: absolute;
			right: -68px;
			bottom: -25px;
			width: 132px;
			height: auto;
		}

		.left {
			position: absolute;
			left: 0;
			top: 150px;
			width: 660px;
			height: 600px;
			border-radius: 24px;
			z-index: 1;
		}

		.right {
			min-height: 600px;
			padding-top: 60px;
			position: relative;
			z-index: 1;

			.right1 {
				display: flex;
				align-items: center;
				font-family: MiSans, MiSans;
				font-weight: 600;
				font-size: 16px;
				color: #999999;
				line-height: 26px;
				text-align: left;
				font-style: normal;

				.icon {
					margin-left: 6px;
					width: 32px;
					height: auto;
				}
			}

			.right2 {
				font-family: Inter, syb;
				font-weight: 600;
				font-size: 52px;
				color: #0B243F;
				line-height: 66px;
				text-align: left;
				font-style: normal;
				margin: 60px 0 24px;
			}

			.right3 {
				font-family: Inter, syn;
				font-weight: 400;
				font-size: 20px;
				color: #666666;
				line-height: 32px;
				text-align: left;
				font-style: normal;
				margin-bottom: 48px;
			}

			.btns {
				display: flex;

				.btn {
					height: 56px;
					border: 1px solid rgba(11, 36, 63, 0.6);
					border-radius: 12px;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: 16px;
					color: #0B243F;
					line-height: 16px;
					text-align: left;
					font-style: normal;
					padding: 0 28px 0 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 16px;
					cursor: pointer;

					img {
						width: 24px;
						height: auto;
						margin-left: 12px;
						display: none;

						&.img1 {
							display: block;
						}

						&.img2 {
							display: none;
						}
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
						color: #fff;

						img {

							&.img1 {
								display: none;
							}

							&.img2 {
								display: block;
							}
						}
					}
				}
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.home-profile {
		width: 100%;
		padding-top: 1rem;
		padding-bottom: 3.1rem;
		position: relative;
		z-index: 1;
		background-color: #F8F8F9;

		&::after {
			content: "";
			position: absolute;
			left: 0;
			bottom: 0;
			width: 6.88rem;
			border-bottom: 1px solid rgba(11, 36, 63, 0.2);
		}

		.left-icon {
			position: absolute;
			left: 0;
			bottom: 0.19rem;
			width: auto;
			height: 1.54rem;
		}

		.center-icon {
			position: absolute;
			width: 6.78rem;
			height: auto;
			left: .36rem;
			bottom: 0;
		}

		.right-icon {
			position: absolute;
			right: 0;
			bottom: -0.26rem;
			width: 1.32rem;
			height: auto;
		}

		.left {
			width: 6.78rem;
			height: auto;
			display: block;
			margin: 0 auto;
			border-radius: 0.28rem;
		}

		.right {
			width: 6.78rem;
			margin: 0 auto;

			.right1 {
				display: none;
			}

			.right2 {
				font-family: Inter, syb;
				font-size: .52rem;
				color: #0B243F;
				line-height: .7rem;
				text-align: left;
				font-style: normal;
				margin: .48rem 0 .28rem;
			}

			.right3 {
				font-family: Inter, syn;
				font-weight: 400;
				font-size: .26rem;
				color: #666666;
				line-height: .4rem;
				text-align: left;
				font-style: normal;
				margin-bottom: .48rem;
			}

			.btns {
				display: flex;

				.btn {
					height: .88rem;
					border: 1px solid rgba(11, 36, 63, 0.6);
					border-radius: .2rem;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: .24rem;
					color: #0B243F;
					line-height: .24rem;
					text-align: left;
					font-style: normal;
					padding: 0 .28rem;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: .12rem;
					cursor: pointer;

					img {
						width: .36rem;
						height: auto;
						margin-left: .12rem;
						display: none;

						&.img1 {
							display: block;
						}

						&.img2 {
							display: none;
						}
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
						color: #fff;

						img {

							&.img1 {
								display: none;
							}

							&.img2 {
								display: block;
							}
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/profile.vue